import { render, staticRenderFns } from "./GolfConveniosTipos.vue?vue&type=template&id=31c483e0"
import script from "./GolfConveniosTipos.vue?vue&type=script&lang=js"
export * from "./GolfConveniosTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports